export default __webpack_public_path__ + "static/media/journeytray-bluetree-fruitnut.00dd601a.svg";